/** Display label for contacts with no assignee; used by grid filters and list API mapping. */
export const ASSIGNEE_UNASSIGNED_LABEL = 'Unassigned';
